"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _redux = require("redux");
var _reduxResponsive = require("redux-responsive");
var _HabitatLauncher = _interopRequireDefault(require("./HabitatLauncher"));
var AppLauncher = /*#__PURE__*/function () {
  function AppLauncher() {
    (0, _classCallCheck2.default)(this, AppLauncher);
    (0, _defineProperty2.default)(this, "startupChecker", null);
    if (!window.dkeReactLauncher) {
      window.dkeReactLauncher = {
        appsLength: -1,
        appRegistered: 0,
        routes: [],
        reducers: {
          browser: (0, _reduxResponsive.createResponsiveStateReducer)({
            XS: 569,
            SM: 819,
            MD: 1069,
            LG: 1319
          }, {
            infinity: 'XL'
          })
        },
        habitatInstance: null,
        rootReducer: null,
        miniAppRouteNames: [],
        hasSetup: false,
        filteredRoutes: []
      };
      this.searchForApps();
    }
    // eslint-disable-next-line no-constructor-return
    return this;
  }
  return (0, _createClass2.default)(AppLauncher, [{
    key: "checkIfPageStarted",
    value: function checkIfPageStarted() {
      if (window.dkeReactLauncher.appRegistered < window.dkeReactLauncher.appsLength) {
        // eslint-disable-next-line max-len, no-console
        console.log("More than 1 minute passed since the initial page load. If you do not see your react components, probably some routes are missing, type 'dkeReactLauncher' in the dev console to debug.");
      }
    }
  }, {
    key: "setAppsLength",
    value: function setAppsLength() {
      var apps = document.getElementsByClassName('react-mini-app');
      for (var i = 0; i < apps.length; i += 1) {
        window.dkeReactLauncher.miniAppRouteNames.push(apps[i].getAttribute('data-component'));
      }
      window.dkeReactLauncher.appsLength = apps.length;
    }
  }, {
    key: "searchForApps",
    value: function searchForApps() {
      this.setAppsLength();
      this.startAllApp();
    }
  }, {
    key: "addRoutes",
    value: function addRoutes(routes) {
      window.dkeReactLauncher.routes = [].concat((0, _toConsumableArray2.default)(window.dkeReactLauncher.routes), (0, _toConsumableArray2.default)(routes));
    }
  }, {
    key: "addReducers",
    value: function addReducers(redursObj) {
      window.dkeReactLauncher.reducers = Object.assign(window.dkeReactLauncher.reducers, redursObj);
    }
  }, {
    key: "startAllApp",
    value: function startAllApp(middlewareConfig) {
      var _this = this;
      this.checkRoutes();
      if (window.dkeReactLauncher.habitatInstance === null && window.dkeReactLauncher.appRegistered >= window.dkeReactLauncher.appsLength && window.dkeReactLauncher.appsLength !== 0) {
        window.dkeReactLauncher.rootReducer = (0, _redux.combineReducers)(window.dkeReactLauncher.reducers);
        window.dkeReactLauncher.habitatInstance = new _HabitatLauncher.default();
        window.dkeReactLauncher.habitatInstance.startRootApp(window.dkeReactLauncher.filteredRoutes, window.dkeReactLauncher.miniAppRouteNames, middlewareConfig);
      } else if (!this.startupChecker) {
        this.startupChecker = setTimeout(function () {
          return _this.checkIfPageStarted();
        }, 60000);
      }
    }
  }, {
    key: "checkRoutes",
    value: function checkRoutes() {
      var numberOfFounds = 0;
      window.dkeReactLauncher.miniAppRouteNames.forEach(function (route) {
        if (window.dkeReactLauncher.routes.find(function (elem) {
          if (!elem.routeName) {
            throw new Error('No route name is provided!');
          }
          if (elem.routeName === route) {
            if (!window.dkeReactLauncher.filteredRoutes.find(function (filteredElem) {
              return filteredElem.routeName === elem.routeName;
            })) {
              window.dkeReactLauncher.filteredRoutes.push(elem);
            }
            return true;
          }
          return false;
        })) {
          numberOfFounds += 1;
        }
      });
      window.dkeReactLauncher.appRegistered = numberOfFounds;
    }
  }, {
    key: "startApp",
    value: function startApp(routes, redursObj) {
      var axiosMiddlewareConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.addRoutes(routes);
      this.addReducers(redursObj);
      this.startAllApp(axiosMiddlewareConfig);
    }
  }]);
}(); // Always export a 'new' instance so it immediately evokes
var _default = exports.default = new AppLauncher();